import React from 'react';

export default function Footer(){
    return (
      <footer className="footer">© 2023 Luna's Delivery Service - A Sister Cat Industries Coroporation</footer>
    )
  }